import usePpraResultsController from './ppra-results.controller';
import PPRAResultsScreen from './ppraResultsScreen';

export default function PpraResultsPage() {
  const { results } = usePpraResultsController();

  return <PPRAResultsScreen results={results} />;
}
